<template>
    <div id="app">
        <Layout></Layout>
    </div>
</template>

<script>
    import Layout from '@/layouts/Default.vue'

    export default {
        data() {
            return {}
        },
        components: {
            Layout
        },
        created() {

        }
    }
</script>

<style>

</style>
